import { PureComponent, StrictMode } from "react";
import { BodyListItem } from "@App/Components/Vehicletree/BodyListItem";
import { Body } from "@App/types";

type BodyListProps = {
  bodies: Body[];
  onClick: (body: Body) => void;
};

export class BodyList extends PureComponent<BodyListProps> {
  render() {
    return (
      <StrictMode>
        <div className="mt-5">
          {this.props.bodies &&
            this.props.bodies.map((body) => (
              <BodyListItem key={body.id} body={body} onClick={this.props.onClick} />
            ))}
        </div>
      </StrictMode>
    );
  }
}
